/**
 * ✏️ **게시본 자막에 빠진 말이 있나** — 게시본 글이 원본 글에 다 들어 있고 원본이 더 길면 「빠졌다」.
 *
 * ## 🔴 왜 (2026-09-10 · 《그레그, 경주로 폴짝!》 34쪽을 스캔본과 하나씩 대조했다)
 * 세 쪽 자막이 스캔본보다 짧았다 — 「경주가 반짝여요.」·「잘 있어!」·「폭신폭신 말랑말랑」.
 * 읽어주기는 **자막으로 만들어서** 아이는 그 말을 **못 들었다.** 아무 검사도 안 잡았다 —
 * 자막이 「있다」는 것만 셌지 「다 있다」는 아무도 안 봤다.
 *
 * ## 낱말 차례로 잰다
 * 게시본의 낱말이 원본에 **같은 차례로 다 있고** 원본이 더 길면 「빠졌다」다.
 *  · 끝이 잘린 것 — 「…빛이 나요.」 → 「…빛이 나요. 경주가 반짝여요.」
 *  · **가운데가 빠진 것** — 「안녕, 경주! 다음엔…」 → 「안녕, 경주! 잘 있어! 다음엔…」
 *    (앞부분만 비교했다면 이것을 놓친다)
 *
 * 🔴 운영자가 **다르게 고쳐 쓴** 글은 여기 안 걸린다 — 낱말이 하나라도 원본에 없으면 그건
 *    빠진 게 아니라 **운영자의 뜻**이다. 그 글은 덮지도, 고치라고 하지도 않는다.
 */
export function subtitleOnlyAdds(have: unknown, want: unknown): boolean {
  const words = (v: unknown) => (typeof v === "string" ? v.trim().split(/\s+/).filter(Boolean) : []);
  const h = words(have);
  const w = words(want);
  if (h.length === 0 || w.length <= h.length) return false;
  let i = 0;
  for (const word of w) if (i < h.length && word === h[i]) i++;
  return i === h.length;
}

/** 자막에 빠진 말이 있는 칸 하나 — 쪽 번호는 1부터(아이가 보는 번호). */
export interface SubtitleGap {
  pageId: string;
  no: number;
  lang: "ko" | "en";
  /** 지금(게시본) 글 */
  have: string;
  /** 원본(저장소) 글 — 이걸로 채운다 */
  want: string;
}

/**
 * 게시본 쪽들과 원본 쪽들을 견주어 **빠진 말이 있는 칸**을 모두 모은다.
 * 관리자 [🎙️ 읽어주기]의 「빠진 말 채우기」와 `pnpm book:seed` 가 **같은 목록**을 본다.
 * 원본에 없는 쪽(운영자가 만든 쪽)은 건드리지 않는다.
 */
export function subtitleGaps(
  live: readonly { id?: unknown; subtitle_ko?: unknown; subtitle_en?: unknown }[],
  repo: readonly { id?: unknown; subtitle_ko?: unknown; subtitle_en?: unknown }[],
): SubtitleGap[] {
  const byId = new Map(repo.map((p) => [String(p.id), p]));
  const out: SubtitleGap[] = [];
  live.forEach((p, i) => {
    const mine = byId.get(String(p.id));
    if (!mine) return;
    for (const lang of ["ko", "en"] as const) {
      const f = lang === "ko" ? "subtitle_ko" : "subtitle_en";
      if (subtitleOnlyAdds(p[f], mine[f])) {
        out.push({ pageId: String(p.id), no: i + 1, lang, have: String(p[f]).trim(), want: String(mine[f]).trim() });
      }
    }
  });
  return out;
}
